import {SimpleUserInfo} from './simple-user-info.model';
import firebase from 'firebase';
import User = firebase.User;

export class SachetEditing {

    date: Date;
    dateTimestamp: number;
    redCounter: number;
    yellowCounter: number;
    user: SimpleUserInfo;

}
